import { render, staticRenderFns } from "./datavisualnotice.vue?vue&type=template&id=cc0d4df8&"
import script from "./datavisualnotice.vue?vue&type=script&lang=js&"
export * from "./datavisualnotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports